module.exports = __webpack_public_path__ + "img/baseline-free_breakfast-24px.da777e25.svg";